import loadable from '@loadable/component';

// IA: webpackChunkName - this is webpack magic comment,
//     it is used to merge multiple components into one chunk
//
// lazy-chunk.s8e - Standalone version only pages(s8e - standalone)
// lazy-chunk.c5t - (c5t - connect)

const AgeGatePage = loadable(() => import(/* webpackChunkName: "lazy-chunk.s8e" */ '../AgeGatePage/AgeGatePage'));
const AppLockedPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.s8e" */ '../AppLockedPage/AppLockedPage'));

const NotCompatibleBrowserPage = loadable(() =>
    import(
        /* webpackChunkName: "lazy-chunk.comp_notComp" */ '../BrowserCompatibility/NotCompatibleBrowserPage/NotCompatibleBrowserPage'
    )
);
const DeviceConnectingPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../DeviceConnectingPage/DeviceConnectingPage')
);
const ErrorHandlingPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../ErrorHandlingPage/ErrorHandlingPage')
);
const LegalDisclaimerPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../LegalDisclaimerPage/LegalDisclaimerPage')
);
const PairingAlertPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingAlertPage/PairingAlertPage')
);
const PairingGuidePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingGuidePage/PairingGuidePage')
);
const PairingSuccessPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingSuccessPage/PairingSuccessPage')
);
const SelectYourDevicePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../SelectYourDevicePage/SelectYourDevicePage')
);
const UpdateFWPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpdateFWPage/UpdateFWPage'));

const PairingGuideHid = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingGuideHid/PairingGuideHid')
);

const SummaryUpdatePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../SummaryUpdatePage/SummaryUpdatePage')
);

const ContactUsPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.s8e" */ '../ContactUsPage/ContactUsPage'));

const CheckingUpdatePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../CheckingUpdatePage/CheckingUpdatePage')
);

const CannotDetectLocationPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../CannotDetectLocationPage/CannotDetectLocationPage')
);

const ImportantPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../ImportantPage/ImportantPage'));

const UpToDatePage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpToDatePage/UpToDatePage'));
const UpToDateFailedPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpToDateFailedPage/UpToDateFailedPage')
);

export default {
    AgeGatePage,
    AppLockedPage,
    CannotDetectLocationPage,
    CheckingUpdatePage,
    ContactUsPage,
    DeviceConnectingPage,
    PairingGuideHid,
    ErrorHandlingPage,
    ImportantPage,
    LegalDisclaimerPage,
    NotCompatibleBrowserPage,
    PairingAlertPage,
    PairingGuidePage,
    PairingSuccessPage,
    SelectYourDevicePage,
    SummaryUpdatePage,
    UpdateFWPage,
    UpToDatePage,
    UpToDateFailedPage,
};
